import React from 'react';

export const WhyCT = [
	{
		id: 1,
		type: 'multicolumn',
		paragraphs: [
			{
				id: 11,
				paragraph: [
					<p>
						Typically, most businesses tend to keep money idle in a current
						account when working capital is not required, which fetches zero
						returns — or they park funds in short term bank deposits where the
						interest rates are abysmal. However, the best case scenario would be
						to optimize the returns from the company’s liquidity and mitigate
						liquidity risk, isn’t it? Since volumes are high, even a miniscule
						change in the rate of return can provide huge monetary value to
						companies.
					</p>,
				],
			},
			{
				id: 12,
				paragraph: [
					<p>
						Apart from maximizing returns from idle funds, a crucial aspect of
						corporate treasury is liquidity management to ensure that the
						company doesn’t face cash crunch in the business cycle.
					</p>,
					<p>
						Plus investing in short term instruments allows healthy use of
						excess cash thereby further boosting reserves. Along with managing
						liquidity a crucial aspect of corporate treasury is to manage risks,
						tax etc. Also by studying cash flow rhythm, corporate treasury
						department plans for any adhoc requirements of cash that may arise.
					</p>,
				],
			},
		],
	},
];
